import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, MenuItem, Menu, 
  // IconButton 
} from "@mui/material";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate, useParams } from "react-router-dom";
import { CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { PiCopyFill } from "react-icons/pi";
import { FaClone } from "react-icons/fa6";
// import { FaRegEdit } from "react-icons/fa";
import { fetchEntityById } from "../../../apis/apiService";

const UserIssue = () => {
  const { id } = useParams();
  const [paginationModal, setPaginationModal] = useState({
    page: 0,
    pageSize: 10,
  });
  const [loading, setLoading] = useState(false);
  const columns = [
    // {
    //   field: "actions",
    //   headerName: "Action",
    //   width: 120,
    //   renderCell: (params) => (
    //     <Box display="flex" alignItems="center">
    //       {/* More options button */}
    //       <IconButton
    //         onClick={(event) => {
    //           event.stopPropagation(); // Prevent row click event
    //           handleMenuOpen(event, params.row.id); // Example menu functionality
    //         }}
    //       >
    //         <MoreVertIcon />
    //       </IconButton>
    //       {/* Edit button */}
    //       <IconButton
    //         onClick={(event) => {
    //           event.stopPropagation(); // Prevent row click event
    //           navigate(`/edit/${params.row.Id}`); // Navigate to specific edit page
    //         }}
    //       >
    //         <FaRegEdit />
    //       </IconButton>
    //     </Box>
    //   ),
    // },
    { field: "issue_id", headerName: "Issue ID", width: 150 },
    { field: "title", headerName: "Issue", width: 150 },
    { field: "project_title", headerName: "Project Name", width: 200 },
    { field: "reporter_name", headerName: "Reporter", width: 150 },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 180,
      renderCell: (params) => {
        const status = params.value;
        let color = params.row.status_colour;

        return (
          <Box
            sx={{
              color: color,
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {status}
          </Box>
        );
      },
    },
    { field: "added_at", headerName: "Created Time", width: 200 },
    { field: "assignee_name", headerName: "Assignee", width: 150 },
    { field: "priority_name", headerName: "Priority", width: 120 },
    { field: "severity_name", headerName: "Severity", width: 120 },
    { field: "due_date", headerName: "Due Date", width: 120 },
  ];
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [Issues, setIssues] = useState([]);
  const navigate = useNavigate();
  const fetchIssues = async () => {
    setLoading(true);
    try {
      const response = await fetchEntityById("getIssueDetails", id);
      // //console.log()("response :");

      if (response?.data?.length > 0) {
        // Flatten all issues from the data array
        // const allIssues = response.data.flatMap((item) => item.issues || []);
                // Flatten all issues, injecting project_title from parent project object
        const allIssues = response.data.flatMap((item) =>
          (item.issues || []).map((issue) => ({
            ...issue,
            project_title:
              issue.project_title ||
              item?.project?.title ||
              "",
          }))
        );

        if (allIssues.length > 0) {
          // //console.log()(allIssues, "Mapped Issues Data");
          setIssues(allIssues);
        } 
        else {
          console.error("No issues found in the response.");
        }
      } 
      else {
        console.error("No data found in the response.");
      }
    } 
    catch (error) {
      console.error("Error fetching issues:", error);
    } 
    finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchIssues();
  }, [id]);

  const handleMenuOpen = (event, taskId) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setSelectedTask(taskId);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };

  const handleClone = () => {
    // //console.log()(`Clone task: ${selectedTask}`);
    handleMenuClose();
  };

  const handleView = () => {
    // //console.log()(`View task: ${selectedTask}`);
    handleMenuClose();
  };
  const handleViewDitailstab = () => {
    // //console.log()(`View task on new tab: ${selectedTask}`);
    handleMenuClose();
  };
  const handleCopylink = () => {
    // //console.log()(`Copy task: ${selectedTask}`);
    handleMenuClose();
  };

  // Handle row click
  const handleRowClick = (params) => {
    const { id } = params.row;
    navigate(`/projects/projectDetail/issue/IssueDetail/${id}`);
  };

  return (
    <>
      <div className="py-3">
        <Box style={{ width: "100%" }}>
          <DataGrid
            rows={Issues}
            columns={columns}
            onRowClick={handleRowClick}
            pagination
            onPaginationModelChange={setPaginationModal}
            paginationModel={paginationModal}
            pageSizeOptions={[10, 20, 30, 40]}
            getRowId={(row) => row?.id || row?.issue_id}
          />

          {/* Menu for Action Button Options */}
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleView}>
              <CiViewList className="me-2" />
              View Details
            </MenuItem>
            <MenuItem onClick={handleViewDitailstab}>
              <MdViewQuilt className="me-2" />
              View Details in New Tab
            </MenuItem>
            <MenuItem onClick={handleCopylink}>
              <PiCopyFill className="me-2" />
              Copy Link
            </MenuItem>
            <MenuItem onClick={handleClone}>
              <FaClone className="me-2" />
              Clone
            </MenuItem>
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default UserIssue;

// {
//     "status": true,
//     "message": "User issue details retrieved successfully",
//     "data": [
//         {
//             "project": {
//                 "project_id": 4,
//                 "project_title": "Xobin Clone",
//                 "current_status_name": "Completed",
//                 "owner_name": "vigneshwaran 123",
//                 "added_by_name": "Poongkannan P",
//                 "updated_name": "Poongkannan P"
//             },
//             "issues": [
//                 {
//                     "issue_id": 38,
//                     "project_id": 4,
//                     "milestone_id": null,
//                     "title": "vicky75123",
//                     "description": "<p>sdfsdf<\/p>",
//                     "due_date": null,
//                     "priority_id": 5,
//                     "severity_id": 1,
//                     "module": "no module",
//                     "added_at": "2025-01-29 15:27:21",
//                     "added_by": 1,
//                     "updated_at": null,
//                     "updated_by": null,
//                     "current_status_id": 13,
//                     "is_active": 1,
//                     "current_status_name": "Open",
//                     "reporter": "Poongkannan P",
//                     "project_title": "Xobin Clone",
//                     "priority_name": "Major",
//                     "severity_name": "Critical",
//                     "status_colour": "red",
//                     "priority_colour": "blue",
//                     "severity_colour": "red",
//                     "assignee": "Lakshmanan L",
//                     "id": 38
//                 }
//             ]
//         },
//         {
//             "project": {
//                 "project_id": 38,
//                 "project_title": "ERIC project",
//                 "current_status_name": "Completed",
//                 "owner_name": "Priyaa",
//                 "added_by_name": "Poongkannan P",
//                 "updated_name": "Poongkannan P"
//             },
//             "issues": [
//                 {
//                     "issue_id": 121,
//                     "project_id": 38,
//                     "milestone_id": 31,
//                     "title": "test",
//                     "description": null,
//                     "due_date": null,
//                     "priority_id": 5,
//                     "severity_id": 2,
//                     "module": null,
//                     "added_at": "2025-02-07 18:44:57",
//                     "added_by": 63,
//                     "updated_at": "2025-02-07 13:27:59",
//                     "updated_by": 82,
//                     "current_status_id": 13,
//                     "is_active": 1,
//                     "current_status_name": "Open",
//                     "reporter": "priya s",
//                     "project_title": "ERIC project",
//                     "priority_name": "Major",
//                     "severity_name": "Major",
//                     "status_colour": "red",
//                     "priority_colour": "blue",
//                     "severity_colour": "blue",
//                     "assignee": "Priyaa",
//                     "id": 121
//                 },
//
//             ]
//         }
//     ]
// }
